export const initProductFilter = () => {
    document.querySelectorAll('.js-product-filters').forEach(function(el) {
        el.addEventListener('click', function(event) {
            let currentPath = window.location.pathname.replace(/\/$/, '');
            let linkPath = el.pathname.replace(/\/$/, '');

            if (linkPath === currentPath && el.classList.contains('current')) {
                event.preventDefault();
                window.location.href = currentPath.substring(0, currentPath.lastIndexOf('/')) || '/';
            }
        });
    });
};